var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('v-autocomplete',{attrs:{"items":_vm.categories,"label":"Category","error-messages":_vm.errorMessages,"item-text":"holeName","item-value":"CAT_ID"},model:{value:(_vm.category),callback:function ($$v) {_vm.category=$$v},expression:"category"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }